import Organization from 'models/organization';
import qconsole from 'scripts/lib/qconsole';

export default class RequestOrganization {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.gateways.organization
      .request()
      .then(organizationDto => {
        this.context.stores.organization.set(Organization.fromJs(organizationDto));
      })
      .catch(err => {
        qconsole.error(`error fetching organization: `, err);
      })
      .finally(() => {
        this.context.stores.organization.resetLoading();
      });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/organization/request_organization.js